export const NOTE_ORDER = ["C", "C#", "D", "D#", "E", "F", "F#", "G", "G#", "A", "A#", "B"];

export const FLAT_TO_SHARP = {
  Db: "C#",
  Eb: "D#",
  Fb: "E",
  Gb: "F#",
  Ab: "G#",
  Bb: "A#",
  Cb: "B",
  "E#": "F",
  "B#": "C",
};

const NO_CHORD_VALUES = new Set(["", "-", "--", "—", "n", "nc", "n.c.", "no chord", "sin acorde"]);

const normalizeAccidental = (note) => FLAT_TO_SHARP[note] || note;

export const normalizePitchClass = (note) => {
  if (!note || typeof note !== "string") return null;
  const match = note.trim().match(/^([A-G](?:#|b)?)/i);
  if (!match) return null;
  const normalizedRoot = `${match[1][0].toUpperCase()}${match[1].slice(1)}`;
  const sharpName = normalizeAccidental(normalizedRoot);
  return NOTE_ORDER.includes(sharpName) ? sharpName : null;
};

const qualityIntervals = (quality) => {
  const normalized = (quality || "")
    .trim()
    .replace(/Δ/g, "maj")
    .replace(/^min/i, "m")
    .replace(/^-/i, "m")
    .toLowerCase();

  if (normalized.includes("sus2")) return [0, 2, 7];
  if (normalized.includes("sus4") || normalized === "sus") return [0, 5, 7];
  if (normalized.includes("aug") || normalized.includes("+")) return [0, 4, 8];
  if (normalized.includes("dim")) return normalized.includes("7") ? [0, 3, 6, 9] : [0, 3, 6];

  if (normalized.startsWith("m") && !normalized.startsWith("maj")) {
    if (normalized.includes("maj7")) return [0, 3, 7, 11];
    if (normalized.includes("7")) return [0, 3, 7, 10];
    return [0, 3, 7];
  }

  if (normalized.includes("maj7") || normalized.includes("ma7")) return [0, 4, 7, 11];
  if (normalized.includes("7")) return [0, 4, 7, 10];

  return [0, 4, 7];
};

export const parseChordSymbol = (symbol) => {
  const raw = typeof symbol === "string" ? symbol.trim() : "";
  if (NO_CHORD_VALUES.has(raw.toLowerCase())) {
    return {
      recognized: false,
      symbol: raw,
      root: null,
      quality: "",
      bass: null,
      notes: [],
      pitchClasses: [],
    };
  }

  const [mainPart, bassPart] = raw.split("/");
  const match = (mainPart || "").trim().match(/^([A-G](?:#|b)?)(.*)$/i);
  if (!match) {
    return {
      recognized: false,
      symbol: raw,
      root: null,
      quality: "",
      bass: null,
      notes: [],
      pitchClasses: [],
    };
  }

  const root = normalizePitchClass(match[1]);
  if (!root) {
    return {
      recognized: false,
      symbol: raw,
      root: null,
      quality: match[2] || "",
      bass: null,
      notes: [],
      pitchClasses: [],
    };
  }

  const bass = normalizePitchClass(bassPart || "");
  const rootIndex = NOTE_ORDER.indexOf(root);
  const intervals = qualityIntervals(match[2]);
  const pitchClasses = intervals.map((interval) => NOTE_ORDER[(rootIndex + interval) % NOTE_ORDER.length]);
  const notes = bass && !pitchClasses.includes(bass) ? [bass, ...pitchClasses] : pitchClasses;

  return {
    recognized: true,
    symbol: raw,
    root,
    quality: match[2] || "",
    bass,
    notes,
    pitchClasses: Array.from(new Set(notes)),
  };
};

export const getChordNotes = (symbol) => parseChordSymbol(symbol).pitchClasses;
